import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { addOrganizationTab, fetchOrganization } from 'redux/modules/organization';
import RaisedButton from 'material-ui/RaisedButton';
import PropTypes from 'prop-types';
import * as styles from './NewClient.scss';
var NewClientSuccess = (_dec = connect(function (state) {
  return {
    theme: state.theme
  };
}, {
  addOrganizationTab: addOrganizationTab,
  fetchOrganization: fetchOrganization
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(NewClientSuccess, _Component);

  var _super = _createSuper(NewClientSuccess);

  function NewClientSuccess() {
    var _this;

    _classCallCheck(this, NewClientSuccess);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleOpenTab", function (orgId) {
      var link = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'schedule';
      return _this.props.fetchOrganization(orgId).then(function (result) {
        _this.props.addOrganizationTab(result.data);

        browserHistory.push("/org/".concat(orgId, "/").concat(link));
      })["catch"](function (err) {
        return console.error(err);
      });
    });

    return _this;
  }

  _createClass(NewClientSuccess, [{
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var _this2 = this;

      return this.props.newOrg ? /*#__PURE__*/React.createElement("div", {
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.successHero
      }, /*#__PURE__*/React.createElement("i", {
        className: "".concat(styles.successHeroCheck, " icon ion-ios-checkmark-outline")
      }), /*#__PURE__*/React.createElement("span", {
        className: styles.successHeroText
      }, "Success!")), /*#__PURE__*/React.createElement("div", {
        className: styles.successHeroBlurb
      }, this.props.newOrg.name, " has been created successfully."), /*#__PURE__*/React.createElement("div", {
        className: styles.successButtonContainer
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.successButtonWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.successButtonWrapText
      }, "Add Social Account"), /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: "GO",
        onClick: function onClick() {
          return _this2.handleOpenTab(_this2.props.newOrg.id, 'settings/social-accounts');
        },
        style: {
          marginTop: 8
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.successButtonWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.successButtonWrapText
      }, "Add Users"), /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: "GO",
        onClick: function onClick() {
          return _this2.handleOpenTab(_this2.props.newOrg.id, 'settings/users');
        },
        style: {
          marginTop: 8
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.successButtonWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.successButtonWrapText
      }, "Set Timezone"), /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: "GO",
        onClick: function onClick() {
          return _this2.handleOpenTab(_this2.props.newOrg.id, 'settings/timezone');
        },
        style: {
          marginTop: 8
        }
      })))) : /*#__PURE__*/React.createElement("div", {
        style: {
          width: '100%'
        }
      }, "Hmm...something went wrong.");
    }
  }]);

  return NewClientSuccess;
}(Component)) || _class);
export { NewClientSuccess as default };